import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface CloseAccountParams {
  clientId: string;
  accountId: string;
  managedAccountId: string;
}

const closeAccount = (params: CloseAccountParams) => {
  return authFetch('/Consumer/ManagedAccounts/CloseAccount', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });
};

export const useCloseAccountMutation = () => {
  return useMutation(closeAccount);
};
